import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Bookmark(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Bookmark", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m34.5538 40.6446-9.3692-5.9724c-.7538-.4977-1.7231-.4977-2.4769 0l-9.3692 5.9724c-1.4.8959-3.3385 0-3.3385-1.5926V8.99081C10 7.89586 10.9692 7 12.1538 7h23.6924C37.0308 7 38 7.89586 38 8.99081V39.052c-.1077 1.5926-2.0462 2.4885-3.4462 1.5926Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27.1111 16.2601 34 17.3584l-5.1111 4.7225L30 29l-6.1111-3.2948-6.2222 3.0751 1.2222-6.8092L14 17.1387l6.8889-.8786L24.1111 10l3 6.2601Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Bookmark.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Bookmark"
};
validateTidalLicense();
export {
  Bookmark
};
//# sourceMappingURL=Bookmark.js.map
